import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { ApiMutation } from '../../../../common/model/api.mutation';

export interface SaveUserModuleSpentDurationParams {
	readonly moduleId: string;
	readonly spentDuration: number;
}

@Injectable({ providedIn: 'root' })
export class SaveUserModuleSpentDurationApiMutation extends ApiMutation<
	void,
	SaveUserModuleSpentDurationParams
> {
	client = 'statistics';
	document = gql`
		mutation SaveUserModuleSpentDuration(
			$moduleId: UUID!
			$spentDuration: Long!
		) {
			saveUserModuleSpentDuration(
				moduleId: $moduleId
				spentDuration: $spentDuration
			)
		}
	`;
	method = 'saveUserModuleSpentDuration';
}
